<template>
  <v-container class="px-2 pt-2">
    <div id="user">
      <v-overlay :value="loading">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
      <search-bar @onSearch="searchByName($event)" />
      <v-virtual-scroll
        :items="items"
        :item-height="130"
        id="userList"
        class="mt-4"
      >
        <template v-slot:default="{ item, index }">
          <v-card
            outlined
            tile
            height="100%"
            class="userInfo"
            :style="{
              'border-left-color': colors[index % 10],
            }"
          >
            <v-card-text style="height: 100%" class="pa-0 px-2">
              <v-row class="ma-0" style="height: 100%">
                <v-col cols="11" class="pa-0">
                  <v-list class="transparent">
                    <v-list-item class="px-0">
                      <v-list-item-title> 用户名 </v-list-item-title>

                      <v-list-item-subtitle class="text-right">
                        {{ item.username }}
                      </v-list-item-subtitle>
                    </v-list-item>
                    <v-list-item class="px-0">
                      <v-list-item-title> 昵称 </v-list-item-title>

                      <v-list-item-subtitle class="text-right">
                        {{ item.displayName }}
                      </v-list-item-subtitle>
                    </v-list-item>
                    <v-list-item class="px-0">
                      <v-list-item-title> 所属区域 </v-list-item-title>

                      <v-list-item-subtitle class="text-right">
                        {{ item.regionName }}
                      </v-list-item-subtitle>
                    </v-list-item>
                    <v-list-item class="px-0">
                      <v-list-item-title> 角色 </v-list-item-title>

                      <v-list-item-subtitle class="text-right">
                        {{ item.userRoles?.map((i) => i.name).join(",") }}
                      </v-list-item-subtitle>
                    </v-list-item>
                  </v-list>
                </v-col>
                <v-col cols="1" class="pa-0 toDetail">
                  <v-btn icon link :to="`/user/detail/${item.id}`">
                    <v-icon large>mdi-chevron-right</v-icon></v-btn
                  >
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </template>
      </v-virtual-scroll>
      <v-row class="ma-0 pt-1">
        <v-spacer></v-spacer>
        <v-btn outlined tile class="success white--text" @click="redirectToAdd"
          >新增</v-btn
        >
      </v-row>
    </div>
  </v-container>
</template>

<script>
import api from "../../api/api";
import SearchBar from "../../components/SearchBar.vue";
export default {
  name: "UserMain",
  components: {
    SearchBar,
  },
  data: () => ({
    loading: false,
    items: [],
    colors: [
      "#D42027",
      "#8E2E62",
      "#893680",
      "#573B8E",
      "#2C3D7D",
      "#322C6F",
      "#089AD3",
      "#04b2d9",
      "#599956",
      "#87b957",
    ],
  }),
  created() {
    this.getUserData();
  },
  methods: {
    searchByName($event) {
      if ($event) {
        this.getUserDataByName($event);
      } else {
        this.getUserData();
      }
    },
    getUserDataByName($event) {
      this.loading = true;
      api.user
        .getUsersWithKeyword($event)
        .then((res) => {
          const { data, status } = res.data;
          if (status == 200 && data) {
            this.items = data;
          } else {
            this.items = [];
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    async getUserData() {
      this.loading = true;
      api.user
        .getUserList()
        .then((res) => {
          const { data, status } = res.data;
          if (status == 200 && data) {
            this.items = data.list;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    redirectToAdd() {
      this.$router.push({
        path: "/user/detail/0",
      });
    },
  },
};
</script>

<style lang="sass">
#user
  height: 100%
  width: 100%
  #userList
    height: calc( 100% - 100px )
    .toDetail
      display: grid
      place-self: center
    .userInfo
      border-left-width: 5px
      border-left-style: solid
      .v-list-item
        min-height: 25px
        .v-list-item__title
          overflow: visible
        .v-list-item__subtitle
          overflow: visible
</style>
